import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../lib/router/withRouter';
import { Form } from '@ant-design/compatible';
import OrderReturnDetailWrap from '../../views/order/return/Detail/OrderReturnDetailWrap';
import { orderActions } from '../../store/modules/order';
import { ORDER_RETURN_STATUS } from '../../constants/service/app/orderConstants';

class OrderReturnDetailContainer extends Component {
  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  initiate = (orderItemId) => {
    const { getOrderReturnDetailList } = this.props;
    getOrderReturnDetailList({
      orderItemId,
    });
  };

  /**
   * 반품 완료처리하기
   */
  onSubmit = () => {
    const { form, orderReturnDetail, setCompleteRefundOrderReturn } = this.props;

    form.validateFieldsAndScroll({ scroll: { offsetBottom: 150, offsetTop: 150 } }, (err) => {
      if (err) return;

      /**
       *  return status 가 반품 승인일때만 반품 완료 처리할 수 있게 한다.
       */
      if (orderReturnDetail.orderReturnStatus !== ORDER_RETURN_STATUS.RETURN_DONE) {
        return;
      }

      const { orderItemId, refundActualAmount, refundCompleteReason, adminMemo, sellerExpectBalanceAmount } =
        orderReturnDetail;

      setCompleteRefundOrderReturn({
        orderItemId,
        refundActualAmount,
        refundCompleteReason,
        adminMemo,
        sellerExpectBalanceAmount,
      });
    });
  };

  /**
   * 최종 환불 금액 변경하기
   */
  onChangeRefundActualAmount = (refundActualAmount) => {
    const { setData, orderReturnDetail } = this.props;
    const { totalPrice, buyerDeliveryExtraFee } = orderReturnDetail;

    /**
     * 판매자가 정산받을 금액
     * 고객 결제 금액 + 고객 부담 추가 배송비 - 최종 환불 금액
     *
     * 정산금액은 음수가 나올 수 없다
     * refundActualAmount 로 포인트 가중치를 보정할때 계산때문에 정산금액이 음수가 나올때 0 으로 보정해준다.
     */
    const sellerExpectBalanceAmount = totalPrice + buyerDeliveryExtraFee - refundActualAmount;
    setData({
      path: ['orderReturnDetail', 'sellerExpectBalanceAmount'],
      value: sellerExpectBalanceAmount > 0 ? sellerExpectBalanceAmount : 0,
    });

    /**
     * 최종 환불 금액
     */
    setData({
      path: ['orderReturnDetail', 'refundActualAmount'],
      value: refundActualAmount,
    });
  };

  render() {
    const { form, orderReturnDetail, setData } = this.props;

    return (
      <OrderReturnDetailWrap
        form={form}
        onSubmit={this.onSubmit}
        onChangeRefundActualAmount={this.onChangeRefundActualAmount}
        orderReturnDetail={orderReturnDetail}
        setData={setData}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    orderReturnDetail: state.order.orderReturnDetail,
  };
};

const mapDispatchToProps = {
  getOrderReturnDetailList: orderActions.getOrderReturnDetailList,
  setCompleteRefundOrderReturn: orderActions.setCompleteRefundOrderReturn,
  setData: orderActions.setData,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Form.create()(OrderReturnDetailContainer)));
